import type { Feature, FeatureModule } from '../../../../types';
import { featureList } from '../../../helpers';
import { DEVELOPMENT_MEMBERSHIP_CARD_DESIGNER_FEATURE_GROUP } from './group';

export const DEVELOPMENT_MEMBERSHIP_CARD_DESIGNER_FEATURES = {
  ACCESS: {
    guid: '3bf3330d-14e7-4be5-8a2c-1f49ac370001',
    name: 'development:membership-card-designer:access',
    description: 'Access the Membership Card Designer development tool',
    action: 'read',
    product: 'app',
    parentGuid: DEVELOPMENT_MEMBERSHIP_CARD_DESIGNER_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { DEVELOPMENT_MEMBERSHIP_CARD_DESIGNER_FEATURE_GROUP } from './group';

export const DEVELOPMENT_MEMBERSHIP_CARD_DESIGNER_MODULE: FeatureModule = {
  product: 'app',
  groups: [DEVELOPMENT_MEMBERSHIP_CARD_DESIGNER_FEATURE_GROUP],
  features: featureList(DEVELOPMENT_MEMBERSHIP_CARD_DESIGNER_FEATURES),
};
